var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Components } from '@pacem/pacem-core';
import { PacemButtonElement } from './button';
//namespace Pacem.Components.UI {
let PacemButtonsetElement = class PacemButtonsetElement extends Components.PacemIterativeElement {
    connectedCallback() {
        super.connectedCallback();
        if (!('tabindex' in this.attributes))
            this.tabIndex = 0;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'index':
                let ndx = 0;
                for (var btn of this.items) {
                    if (ndx == val) {
                        btn.focus();
                        break;
                    }
                    ndx++;
                }
                break;
        }
    }
    validate(item) {
        return item instanceof PacemButtonElement;
    }
};
PacemButtonsetElement = __decorate([
    CustomElement({
        tagName: P + '-buttonset'
    })
], PacemButtonsetElement);
export { PacemButtonsetElement };
//}
